/* esm.sh - applesauce-core@5.2.0/dist/helpers/pointers */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/pointers.mjs";
